import { usePageTitle } from '../../hooks/usePageTitle';
import { PlaceholderPage } from '../_shared/PlaceholderPage';

export function StatistichePlaceholderPage() {
  usePageTitle('Statistiche');
  return (
    <PlaceholderPage
      title="Statistiche"
      subtitle="Andamento studio, fatturato, aderenza pazienti."
      icon="monitoring"
    />
  );
}

export default StatistichePlaceholderPage;
